import axios from 'axios'
import config from '../config'


const Coupon = {
    state: {
        couponList: [],
        couponDetail: [],
        error: false,
        msg: ''
    },
    mutations: {
        CouponList: (state, couponList) => state.couponList = couponList,
        CouponDetail: (state, couponDetail) => state.couponDetail = couponDetail,
        ERROR: (state, error) => state.error = error,
        MSG: (state, msg) =>  state.msg = msg
    },
    actions: {
        async fetchCouponList({commit}, data){
            await axios({
                method:'post',
                url: config.LOAD_COUPON_LIST,
                data: data
            })
            .then((result) => {
                commit('CouponList', result.data.coupons)
            }).catch((err) => {
                console.log(err);
            });
        },
        async fetchCouponDetail({commit}, data){
            await axios({
                method:'post',
                url: config.LOAD_COUPON_DETAIL,
                data: data
            })
            .then((result) => {
                commit('CouponDetail', result.data.coupon)
            }).catch((err) => {
                console.log(err);
            });
        },
        async addCoupon({commit}, data){
            await axios({
                method:'post',
                url: config.ADD_COUPON,
                data: data
            })
            .then((result) => {
                commit('ERROR', result.data.error)
                commit('MSG', result.data.msg)
            }).catch((err) => {
                console.log(err)
            });
        },
        async updateCoupon({commit}, data){
            await axios({
                method:'post',
                url: config.COUPON_UPDATE,
                data: data
            })
            .then((result) => {
                console.log(result)
                commit('ERROR', result.data.error)
                commit('MSG', result.data.msg)
            }).catch((err) => {
                console.log(err)
            });
        },
        async updateCouponStatus({commit}, data){
            await axios({
                method:'post',
                url: config.COUPON_UPDATE_STATUS,
                data: data
            })
            .then((result) => {
                console.log(result)
                commit('ERROR', result.data.error)
                commit('MSG', result.data.msg)
            }).catch((err) => {
                console.log(err)
            });
        }
    },
    getters: {
            getCouponList: state => state.couponList,
            getCouponDetail: state => state.couponDetail,
            getCouponError: state => state.error,
            getCouponMsg: state => state.msg
    }
}

export default Coupon;